import { useState, useEffect, useContext } from "react";
import { Link, NavLink, useLocation, useSearchParams } from "react-router-dom";
import { LocaleContext } from "../../../routing/LangRouter";
import { Grid } from "@mui/material";

//import general components
import BasePopover from "../base-popover/base-popover";

//import view components
import ProfileWidget from "../profile-widget/profile-widget";
import LanguageSelector from "../language/language";

//import images and icons
import logoImage from "../../../assets/imgs/green logo.png";
import { ArrowLeft2, User } from "iconsax-react";

//import styles
import "./header.scss";

function DesktopHeader({ menuList, handleMenuClick }) {
    //general variables
    const location = useLocation();
    const [_, setSearchParams] = useSearchParams();
    const { locale } = useContext(LocaleContext);
    const accessToken = localStorage.getItem("accessToken");

    //check for token existance
    const [isLogin, setIsLogin] = useState(false);
    useEffect(() => {
        setIsLogin(!!accessToken);
    }, [accessToken]);

    //open the login modal
    const openLoginModal = () => {
        if (location.pathname === `/${locale}/login`) {
            return;
        }
        setSearchParams({ action: "login" });
    };

    //Popover
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeMenuId, setActiveMenuId] = useState(null);

    const handleOpenPopover = (event, menuId) => {
        setAnchorEl(event.currentTarget);
        setActiveMenuId(menuId);
    };

    const handleClosePopover = () => {
        setAnchorEl(null);
        setActiveMenuId(null);
    };

    const isPopoverOpen = Boolean(anchorEl);
    const popoverId = isPopoverOpen ? "language-popover" : undefined;

    return (
        <Grid container item xs={12} justifyContent="space-between" alignItems="center">
            <Grid container item md={10} lg={9} columnGap={3}>
                <Link to={`/${locale}/flight-search/domestic`} onClick={() => sessionStorage.clear()}>
                    <Grid className="header__logo-image" component="img" src={logoImage} container item xs="auto" alignItems="center" />
                </Link>

                <Grid component="ul" container item xs="auto" columnGap={{ xs: 1, lg: 1 }}>
                    {menuList.map((menuItem, index) => {
                        return (
                            <Grid
                                className={`header__menu-item ${locale === "en" ? "ltr" : "rtl"}`}
                                component="li"
                                key={menuItem?.id}
                                container
                                item
                                xs={12}
                                md="auto"
                                justifyContent={{ xs: "center", md: "flex-start" }}
                                alignItems="center"
                                ml={6}
                            >
                                <NavLink
                                    className="header__menu-link"
                                    to={menuItem?.to}
                                    onClick={
                                        !!menuItem?.subMenu
                                            ? event => handleOpenPopover(event, menuItem.id)
                                            : event => handleMenuClick(event, menuItem)
                                    }
                                >
                                    {menuItem.label}
                                    {menuItem.icon}
                                </NavLink>

                                {!!menuItem?.subMenu && (
                                    <BasePopover
                                        id={`popover-${menuItem.id}`}
                                        open={activeMenuId === menuItem.id}
                                        anchorEl={anchorEl}
                                        handleClose={handleClosePopover}
                                        width="12%"
                                        vertical="bottom"
                                        horizontal="right"
                                        radius="0 0 0.5rem 0.5rem"
                                    >
                                        {menuItem.subMenu.map(sub => {
                                            return (
                                                <NavLink
                                                    key={sub?.id}
                                                    className={`header__menu-link ${sub.to === location.pathname && "activeItem"}`}
                                                    to={sub?.to}
                                                    onClick={event => {
                                                        handleMenuClick(event, sub);
                                                        handleClosePopover();
                                                    }}
                                                >
                                                    {sub.to === location.pathname && (
                                                        <ArrowLeft2 size="20" color="var(--primary-color)" variant="Bold" />
                                                    )}
                                                    {sub.label}
                                                </NavLink>
                                            );
                                        })}
                                    </BasePopover>
                                )}
                            </Grid>
                        );
                    })}
                </Grid>
            </Grid>

            <Grid container item xs="auto" columnGap={1} justifyContent="flex-end">
                {isLogin ? (
                    <ProfileWidget handleTokenExist={setIsLogin} />
                ) : (
                    <div className="header__signin" onClick={openLoginModal}>
                        <User size="24" color="var(--teal-color-18)" variant="Outline" />
                    </div>
                )}

                <LanguageSelector />
            </Grid>
        </Grid>
    );
}

export default DesktopHeader;
